export default __webpack_public_path__ + "static/Tra_Hoang-8859b8a562be72df349dd4b8f1572e20.png";